import { Controller } from '@hotwired/stimulus';

export class WelcomeSetupController extends Controller<HTMLFormElement> {
    static targets = ['activityOptions', 'customActivityOptions', 'calorieLockQuestion', 'pinField', 'selectedInterests', 'selectedActivityMode', 'selectedDetailedTraining'];
    static values = { hasExistingPin: Boolean };

    declare readonly activityOptionsTarget: HTMLElement;
    declare readonly customActivityOptionsTarget: HTMLElement;
    declare readonly calorieLockQuestionTarget: HTMLElement;
    declare readonly pinFieldTarget: HTMLElement;
    declare readonly hasActivityOptionsTarget: boolean;
    declare readonly hasCustomActivityOptionsTarget: boolean;
    declare readonly hasCalorieLockQuestionTarget: boolean;
    declare readonly hasPinFieldTarget: boolean;
    declare readonly hasExistingPinValue: boolean;
    declare readonly selectedInterestsTarget: HTMLInputElement;
    declare readonly hasSelectedInterestsTarget: boolean;
    declare readonly selectedActivityModeTarget: HTMLInputElement;
    declare readonly hasSelectedActivityModeTarget: boolean;
    declare readonly selectedDetailedTrainingTarget: HTMLInputElement;
    declare readonly hasSelectedDetailedTrainingTarget: boolean;

    connect(): void {
        this.refresh();
    }

    refresh(): void {
        const activitySelected = this.checked('interests', 'activity_training');
        const activityMode = this.value('activity_mode');
        const caloriesHidden = this.value('show_calories') === 'no';
        const caloriesLocked = this.value('lock_calories') === 'yes';

        if (this.hasSelectedInterestsTarget) {
            this.selectedInterestsTarget.value = Array.from(
                this.element.querySelectorAll<HTMLInputElement>('input[name="interests"]:checked'),
            ).map((input) => input.value).join(',');
        }
        if (this.hasSelectedActivityModeTarget) {
            this.selectedActivityModeTarget.value = activityMode || '';
        }
        if (this.hasSelectedDetailedTrainingTarget) {
            this.selectedDetailedTrainingTarget.value = this.value('detailed_training') || '';
        }

        if (this.hasActivityOptionsTarget) {
            this.activityOptionsTarget.classList.toggle('hidden', !activitySelected);
        }
        if (this.hasCustomActivityOptionsTarget) {
            this.customActivityOptionsTarget.classList.toggle(
                'hidden',
                !activitySelected || activityMode !== 'custom_activity',
            );
        }
        if (this.hasCalorieLockQuestionTarget) {
            this.calorieLockQuestionTarget.classList.toggle('hidden', !caloriesHidden);
        }
        if (this.hasPinFieldTarget) {
            this.pinFieldTarget.classList.toggle('hidden', !caloriesHidden || !caloriesLocked);
        }

        if (this.hasPinFieldTarget) {
            for (const input of this.pinFieldTarget.querySelectorAll<HTMLInputElement>('input')) {
                input.required = caloriesHidden && caloriesLocked && !this.hasExistingPinValue;
            }
        }
    }

    private checked(name: string, value: string): boolean {
        return Boolean(this.element.querySelector<HTMLInputElement>(
            `input[name="${name}"][value="${value}"]:checked`,
        ));
    }

    private value(name: string): string | null {
        return this.element.querySelector<HTMLInputElement>(`input[name="${name}"]:checked`)?.value || null;
    }
}
